import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa";
import "../css/PopularDestination.css";
import { goToBlock } from "../utils/navigation";

const cardBackground = "#ffffff";
const cardShadow = "0 6px 20px rgba(0, 0, 0, 0.1)";
const cardBorderRadius = "12px";

const DestinationDetails = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const destination = state?.destination;

  if (!destination) {
    return (
      <div className="error-container text-center py-5">
        <h2>Destination Not Found</h2>
      </div>
    );
  }
  return (
    <>
      {/* Top Banner */}
      <div
        className="banner"
        style={{
          backgroundImage: `url('${destination.bannerImg ||
            destination.data?.[0]?.images?.[0] ||
            "/images/placeholder.jpg"
            }')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "300px",
          position: "relative",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "2.5rem",
          fontWeight: "bold",
          textShadow: "0 2px 5px rgba(0,0,0,0.6)",
        }}
      >
        {destination.title}
      </div>

      {/* Description */}
      <section className="details-hero text-center py-4">
        <div className="container">
          <p className="subtitle1">{destination.desc2}</p>
        </div>
      </section>

      {/* Cards Section */}
      <section className="ravelo-style-cards container my-5">
        <div className="row">
          {destination.data?.map((block, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="card-box text-dark p-3 h-100 d-flex flex-column"
                style={{
                  backgroundColor: cardBackground,
                  borderRadius: cardBorderRadius,
                  boxShadow: cardShadow,
                  transition: "transform 0.3s ease",
                }}
              >
                {/* Thumbnail */}
                {Array.isArray(block.images) && block.images[0] && (
                  <img
                    src={block.images[0]}
                    alt={block.title}
                    style={{
                      width: "100%",
                      height: "160px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      marginBottom: "0.7rem",
                    }}
                  />
                )}
                {/* Title & Description */}
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">{block.title}</h6>
                  <button
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => goToBlock(navigate, block, destination.title, destination)}
                >
                    Explore ➔
                  </button>
                </div>
                <p className="small mb-2 text-muted" style={{ lineHeight: "1.4em" }}>
                  {block.items?.[0] || ""}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default DestinationDetails;
